/** 한 글자 어절이 줄 끝에 남지 않도록 다음 단어와 붙인다. */
const SHORT_WORD = /(?<=^|\s)([가-힣]) (?=\S)/g
/** 가운데점(·) 묶음이 줄 앞뒤로 떨어지지 않게 앞뒤 단어와 붙인다. 이미 붙인 묶음은 다시 건드리지 않는다. */
const MIDDOT = /(\S) · (\S)/g

export function glueKoreanLine(text: string): string {
  let next = text.replace(SHORT_WORD, '$1\u00A0')
  let prev = ''
  while (next !== prev) {
    prev = next
    next = next.replace(MIDDOT, '$1\u00A0·\u00A0$2')
  }
  return next
}

export function glueKoreanTree(root: ParentNode) {
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
    acceptNode(node) {
      const parent = (node as Text).parentElement
      if (!parent) return NodeFilter.FILTER_REJECT
      if (parent.closest('script,style,textarea,input,noscript')) return NodeFilter.FILTER_REJECT
      return NodeFilter.FILTER_ACCEPT
    },
  })
  const nodes: Text[] = []
  let current = walker.nextNode()
  while (current) {
    nodes.push(current as Text)
    current = walker.nextNode()
  }
  for (const node of nodes) {
    const value = node.textContent || ''
    if (!/(?:^|\s)[가-힣] \S/.test(value) && !/\S · \S/.test(value)) continue
    const next = glueKoreanLine(value)
    if (next !== value) node.textContent = next
  }
}
